import Mail from './Mail';

export default Mail
export { Mail as Base }
